/**
 * Codes are sent to the account's email address
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_EMAIL = 'email';

/**
 * Codes are texted to the account's mobile number
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_SMS = 'sms';

/**
 * Codes are generated by an authenticator app, never sent
 *
 * @type {string}
 */
export const TWO_FACTOR_CHANNEL_TOTP = 'totp';

/**
 * Number of digits in a verification code
 *
 * @type {number}
 */
export const TWO_FACTOR_CODE_LENGTH = 6;

/**
 * Seconds to wait between resend requests
 *
 * @type {number}
 */
export const TWO_FACTOR_RESEND_COOLDOWN = 60;

/**
 * Attempts allowed on a challenge before it is thrown away
 *
 * @type {number}
 */
export const TWO_FACTOR_MAX_ATTEMPTS = 5;

/**
 * Days to keep a trusted device token. Server side trust expires at midnight
 * Monday NZ time, so nothing past a week is worth holding.
 *
 * @type {number}
 */
export const TRUSTED_DEVICE_TOKEN_DAYS = 8;

/**
 * Human labels for each channel, shown on the enrolment choice screen.
 *
 * @type {Object.<string, string>}
 */
export const TWO_FACTOR_CHANNEL_LABELS = {
  [TWO_FACTOR_CHANNEL_EMAIL]: 'Email',
  [TWO_FACTOR_CHANNEL_SMS]: 'Text message',
  [TWO_FACTOR_CHANNEL_TOTP]: 'Authenticator app',
};

/**
 * Short descriptions for each channel on the enrolment choice screen.
 *
 * @type {Object.<string, string>}
 */
export const TWO_FACTOR_CHANNEL_DESCRIPTIONS = {
  [TWO_FACTOR_CHANNEL_EMAIL]:
    'We email you a 6-digit code each time you log in.',
  [TWO_FACTOR_CHANNEL_SMS]: 'We text you a 6-digit code each time you log in.',
  [TWO_FACTOR_CHANNEL_TOTP]:
    'An app such as Google Authenticator or 1Password generates a code for you. Nothing is sent, so it works without phone reception.',
};
